import axios from '@/axios';
import auth from '@/api/v1/auth';

const INDEX_URL = '/students/refresh';
const UPDATE_URL = '/students';

export default {
  show(succ) {
    axios.get(INDEX_URL)
      .then((response) => { succ(response.data[auth.user.user_type]); });
  },
  update(user, succ, err) {
    axios.patch(UPDATE_URL, { student: user })
      .then(() => { succ(); })
      .catch((error) => {
        err(error);
      });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/student.js